import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as tag from '../../../tag'
import * as content from '../../content'

/** TODO:  */
@ngCore.Component({
  imports: [content.list.Component, content.standard.Component, tag.Component],
  selector: 'atn-enum-switcher',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link ents.core.common.value.types.Enum} */
  public readonly enumSg =
    ngCore.input.required<ents.core.common.value.types.Enum>({
      alias: 'enum',
    })

  /**
   * @default undefined
   * @see {@link ents.core.common.value.Raw}
   */
  public readonly valueSg = ngCore.input<
    ents.core.common.value.Raw | undefined
  >(undefined, {
    alias: 'value',
  })

  /** @see {@link ents.core.common.value.types.Enum.isMultiselect}  */
  public readonly singleSelectValueSg = ngCore.computed(
    (_enum = this.enumSg(), value = this.valueSg()) =>
      !_enum.isMultiselect
        ? ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.Text,
          )
        : undefined,
  )
  /** @see {@link ents.core.common.value.types.Enum.isMultiselect}  */
  public readonly multiSelectValueSg = ngCore.computed(
    (_enum = this.enumSg(), value = this.valueSg()) =>
      _enum.isMultiselect
        ? ents.core.common.value.Raw.cast(
            value,
            ents.core.common.value.types.Intrinsic.List,
          )
        : undefined,
  )
}
